import React, { useState } from 'react';
import SimpleMDE from 'react-simplemde-editor';
import 'easymde/dist/easymde.min.css'; // Import the CSS for SimpleMDE
import { addEssay } from '../utils/utils';
import  {useMemo } from 'react';
import './AddEssay.css';

const AddEssay = () => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [isLoading, setIsLoading] = useState(false); // Track loading state
    const [error, setError] = useState(''); // Track errors


    const editorOptions = useMemo(() => ({
        spellChecker: false,
        placeholder: "Write your essay here...",
        toolbar: [
            "bold",
            "italic",
            "heading",
            "|",
            "quote",
            "code",
            "unordered-list",
            "ordered-list",
            "|",
            "preview",
            "guide",
        ],
    }), []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(''); // Clear any previous errors
        try {
            await addEssay(title, content); // Submit the title and markdown content
            setTitle('');
            setContent('');
            alert('Essay added successfully!');
        } catch (err) {
            console.error('Error adding essay:', err.message);
            setError('Failed to add essay. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="add-essay-container">
            <h1 className="add-essay-title">Add New Essay</h1>
            {error && <p className="error-message">{error}</p>} {/* Display error message */}
            <form className="add-essay-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="title">Title</label>
                    <input
                        type="text"
                        id="title"
                        className="form-control"
                        placeholder="Enter essay title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                        disabled={isLoading} // Disable input while loading
                    />
                </div>
                <div className="form-group">
                    <label>Content</label>
                    <SimpleMDE
                        value={content}
                        onChange={setContent}
                        options={editorOptions}
                    />
                </div>
                <button type="submit" className="btn-submit" disabled={isLoading}>
                    {isLoading ? 'Submitting...' : 'Submit'} {/* Change button text based on loading state */}
                </button>
            </form>
        </div>
    );
};

export default AddEssay;
